import { render, staticRenderFns } from "./new-order.vue?vue&type=template&id=1086b63b&scoped=true"
import script from "./new-order.vue?vue&type=script&lang=js"
export * from "./new-order.vue?vue&type=script&lang=js"
import style0 from "./new-order.vue?vue&type=style&index=0&id=1086b63b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1086b63b",
  null
  
)

export default component.exports